import { useSelector } from 'react-redux';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import dateformat from 'dateformat';
import { Loading } from '../../components/Loading';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import LineBreak from '../../components/LineBreak';
import Api, { createFetchErrorMessage } from 'utils/api/Api';



export const BoardQnaView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { school, id } = useParams();
    const auth = useSelector(state => state.auth);
    const queryClient = useQueryClient();

    const { data: qna, isLoading, isError, error } = useQuery({
        queryKey: ['board/qna', id],
        queryFn: () => Api.get(`/api/board/qna/${id}`),
        retry: false,
        refetchOnMount:'always',
    });

    const qnaDeleteMutate = useMutation({
        mutationFn: () => Api.get(`/api/board/qna/${id}/delete`),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['board/qna/list', { page: 0, user: 'N', school: '' }] });
            navigate(`/${school}/board/qna`)
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err, '삭제에 실패했습니다.');
            toast.error(errorData.message);
        }
    })

    const onClickDelete = () => {
        if (qnaDeleteMutate.isPending) return;
        qnaDeleteMutate.mutate();
    }

    if (isLoading) return <Loading />
    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message}
        goto={<Link className="btn _border" to={`/${school}/board/qna${location.search}`} >목록</Link>} />


    return (
        <div className="section">
            <div className="inner">
                <div className="bbs_view">
                    <div className="title_area">
                        <h3>{qna.data?.title} {qna.data?.isSecret === "Y" && (<i className="icon fas fa-lock"></i>)}</h3>
                        <div className="info_wrap clear">
                            <div className="writer"><span>등록자</span><span>{qna.data?.user?.name || qna.data?.name}</span></div>
                            <div className="date"><span>등록일</span><span>{qna.data?.createdAt && dateformat(qna.data?.createdAt.substring(0, 20), 'yyyy.mm.dd HH:MM:ss')}</span></div>
                        </div>
                    </div>

                    <div className="cont_area editor_view">
                        <LineBreak content={qna.data?.content} />

                        {qna.data?.reply && (
                            <div className="reply_area">
                                <span className="icon">답변</span>
                                <div className="reply_cont">
                                    <LineBreak content={qna.data?.reply} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>





            <div className="bbs_btn alignC">
                {qna.data?.user?.id === auth.id &&
                    <>
                        <Link className="btn _blue" to={`/${school}/board/qna/edit/${id}${location.search}`} >수정</Link>
                        <button className="btn _red" onClick={onClickDelete} >삭제</button>
                    </>
                }
                <Link className="btn _border" to={`/${school}/board/qna${location.search}`}>목록</Link>
            </div>
        </div>
    );
};